import { Flex, Tag } from 'antd';
import type React from 'react';
import { AutoTitle } from '../../../../components/AutoTitle.tsx';
import type { LabResultObservationResult } from '../../../../generated/openapi/befunde-api';
import { useCumulativeResultsCellStyles } from './useCumulativeResultsCellStyles.ts';

export const CumulativeLabResultObservationResultCell: React.FC<{ result: LabResultObservationResult | null }> = ({ result }) => {
  const styles = useCumulativeResultsCellStyles(!!result?.pathological);

  return (
    <Flex vertical>
      <Flex className={styles.value}>
        <AutoTitle content={result?.measuredValue} />
        {result?.pathological && (
          <Tag color="red" className={styles.tag}>
            {result?.pathological}
          </Tag>
        )}
      </Flex>
      <div className={styles.sub}>{result?.standardRange}</div>
    </Flex>
  );
};
